import { Alert } from "@mui/material";
import AlertTitle from "@mui/material/AlertTitle";
import { APP_FONT_FAMILIES } from "../../../enums/fonts";

function AppAlert({ title = "", textAlign, children, ...props }: any) {
  if (!children) return null;

  return (
    <Alert
      {...props}
      sx={{
        textAlign,
        ...props.sx,
      }}
    >
      {title && <AlertTitle fontSize={"small"} fontWeight={500} fontFamily={APP_FONT_FAMILIES.ibmPlexMono}>{title}</AlertTitle>}
      {children}
    </Alert>
  );
}

export { AppAlert };
